import React, { FC } from "react";

import { IDNDList } from "@websential/cosmic-v20";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { DragDropDDLPanel, IMoveItemsPayload } from "../../../../DragDropDDLPanel";

export interface IEmployeelistAndAssignedEmployeesPanel {
    firstList: IDNDList;
    secondList: IDNDList;
    onListsChange: (updatedFirstList: IDNDList, updatedSecondList: IDNDList) => void;
    onMoveItems: (payload: IMoveItemsPayload) => void;
    isLoading: boolean;
}

export const EmployeelistAndAssignedEmployeesPanel: FC<IEmployeelistAndAssignedEmployeesPanel> = ({
    firstList,
    secondList,
    onListsChange,
    onMoveItems,
    isLoading,
}) => {
    return (
        <DragDropDDLPanel
            firstList={firstList}
            secondList={secondList}
            firstListConfig={{
                title: "Employee List",
                emptyTitle: "No employees here",
                emptySubtitle: "Drag someone in, or select on the other side",
            }}
            secondListConfig={{
                title: "Assigned Employees",
                emptyTitle: "No employees here",
                emptySubtitle: "Drag someone in, or select on the other side",
            }}
            itemIcon={<PersonRoundedIcon sx={{ fontSize: 15 }} />}
            onListsChange={onListsChange}
            onMoveItems={onMoveItems}
            isLoading={isLoading}
            accentColor="#0091b3"
            testId="employee-list-and-assigned-employees-panel"
        />
    );
};

export default EmployeelistAndAssignedEmployeesPanel;